import React, { Fragment } from 'react'
import './contact.css'

const Contact = (props) => {
  return (
    <div className="contact-container">
      <div className='contact-header flex'>
        <div className='container mx-auto px-4 py-4 flex justify-between items-center'>
          <a href="/" className="flex items-center gap-2">
            <img src="images/dopo-logo.svg" alt="ITEnterprise Logo" width={60} height={34} className="" />
          </a>
          <div className='flex items-center gap-48'>
            {/* Mobile Menu Button */}
            <div className='md:hidden flex items-center gap-32 ml-auto'>
              <button
                onClick={() => {
                  window.location.href = "tel:+919448321546"; // Replace with the desired phone number
                }}
              >
                <img src="images/phone-call.svg" alt="Menu Close" width={24} height={24} />
              </button>
            </div>

            <div className="hidden md:flex items-center gap-2">
              <img src='images/phone.png' width={28} height={28} alt='Phone' />
              <span className="header-menu-color text-sm font-semibold">+91 9448321546</span>
            </div>

            <button 
              onClick={() => {
                // Close the modal if props.close exists
                if (props.close) props.close();
            
                // DOM manipulation to update classes
                const aboutUsElement = document.querySelector('nav .about-us');
                const homeElement = document.querySelector('nav .home');
            
                if (aboutUsElement) aboutUsElement.classList.remove('selected');
                if (homeElement) homeElement.classList.add('selected');
              }}
            >
              <img className="ml-auto" src="images/close.svg" alt="ITEnterprise Logo" width={28} height={28} />
            </button>
          </div>
        </div>
      </div>
      <section className="contact-content">
        <div className="container mx-auto px-4">
          <form className='lg:p-8 md:p-6 p-6 contact-form'>
              <h2>Let's Talk!</h2>
              <p>Please fill this form, and we'll get back to you through email!</p>
              <div className='form-field'>
                <div>
                  <label htmlFor="email">Email<span>*</span></label>
                  <input id="email-field" type="email" required />
                </div>
                <div>
                  <label htmlFor="subject">Subject<span>*</span></label>
                  <input id="subject-field" type="text" required />
                </div>
                <div>
                  <label htmlFor="description">Description<span>*</span></label>
                  <textarea id="description-field" required></textarea>
                </div>
              </div>    
              <div className='form-action'>
                <button 
                  type="submit" 
                  className='submit'
                  onClick={() => {
                    // Get input field values
                    const emailField = document.getElementById('email-field');
                    const subjectField = document.getElementById('subject-field');
                    const descriptionField = document.getElementById('description-field');

                    const email = emailField ? emailField.value.trim() : '';
                    const subject = subjectField ? subjectField.value.trim() : '';
                    const description = descriptionField ? descriptionField.value.trim() : '';

                    // Validate fields
                    if (!email || !subject || !description) {
                      alert('All fields are required!');
                      return;
                    }

                    // Construct mailto URL and open it
                    const mailtoUrl = `mailto:info@dopoindia.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(description)}%0A%0AFrom: ${encodeURIComponent(email)}`;
                    window.open(mailtoUrl);

                    // Show success message
                    alert('Email submitted successfully!');

                    // Close the modal if props.close exists
                    if (props.close) props.close();

                    // DOM manipulation to update classes
                    const aboutUsElement = document.querySelector('nav .about-us');
                    const homeElement = document.querySelector('nav .home');

                    if (aboutUsElement) aboutUsElement.classList.remove('selected');
                    if (homeElement) homeElement.classList.add('selected');
                  }}
                >
                  Submit
                </button>
                <button
                  type="reset"
                  className='cancel'
                  onClick={() => {
                    // Close the modal if props.close exists
                    if (props.close) props.close();
                
                    // DOM manipulation to update classes
                    const aboutUsElement = document.querySelector('nav .about-us');
                    const homeElement = document.querySelector('nav .home');
                
                    if (aboutUsElement) aboutUsElement.classList.remove('selected');
                    if (homeElement) homeElement.classList.add('selected');
                  }}
                >
                  Cancel
                </button>
              </div>
          </form>      
        </div>
      </section>
      {/* <div className='about-bg'></div> */}
    </div>
  )
}

export default Contact;
